import(/* webpackMode: "eager" */ "/vercel/path0/apps/helio/src/app/global-error.tsx");
